import type { HttpGet } from '@/shared/infra/http'
import type { BirdHarvest, BirdHarvestSex } from '@/shared/domain/bird-harvest'
import type { LoadBirdHarvests } from '@/shared/domain/use-cases'

function toBirdHarvest(wire: Record<string, unknown>): BirdHarvest {
  return {
    speciesId: wire.speciesId as string,
    speciesName: wire.speciesName as string,
    recordingUserId: wire.recordingUserId as string,
    assignedUserId: (wire.assignedUserId as string) ?? undefined,
    sex: wire.sex as BirdHarvestSex,
    wingidAnalysisId: (wire.wingidAnalysisId as string) ?? undefined,
  }
}

export class EdgeLoadBirdHarvestsRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadBirdHarvests = async (params) => {
    const result = await this.http.get<{ harvests: Record<string, unknown>[] }>({
      url: `/bird-harvests/${params.huntId}`,
    })
    return result.harvests.map(toBirdHarvest)
  }
}
